// 非结构构件 - 隔墙
import store from "@/store/index";
import rlModelData from "@/rlMxModules/rlDataClass/rlModelData";
import {
  getEntityData,
  saveDatabaseStore,
} from "@/rlMxModules/operate/operateApi";
import { McGePoint3d, McDbPolyline, McCmColor } from "mxcad";
import { rlTextData } from "./rlTextData";
import { getPKPM_PartitionWallData } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import { isPointEqual, MovePt } from "@/rlMxModules/operate/structural";
import { areLineCollinear } from "@/rlMxModules/operate/operateApi";
class rlPartitionWallData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_WallData = store.state.globalData.rl_wasm_module.getPKPM_WallData;
  constructor() {
    super();
    this.componentType = "partitionWall";
    this.points = []; // 顶点数据
    this.deviation = 0.00005;
    this.m_gridData = {}; //关联的网格数据
    // this.m_sectParamData = {}; //墙截面数据
    // this.SectData = []; //墙截面组合数据

    this.Ecc = null; //墙偏轴距离

    this.Attribute = 0; //默认为主要构件
    this.classTypeName = "rlPartitionWallSeg"; // 隔墙
    this.partitionWallHeight = null; //隔墙高度
    this._threeObj = null; ////三维图形对象

    this.Color = null;
    this.Mat = null; //材料
    this.MatName = ""; //材料名称
    this.ModelType = "隔墙";

    this.m_groupName = "rlPartitionWallGroup"; //组名

    this.isWasmGeted = false; //是否已经获取wasm数据
    this.nonStructural = true; //非结构构件标识
    this.startPoint = null;
    this.endPoint = null;
    this.m_HoleIdArray = []; //门窗Id
    this.LinkGuids = []; //存能合并为同一条梁的其他梁的guid
    this.useFunctionNames = []; //隔墙线名称
    this.otherDrawIds = []; //当门窗布置之后,隔墙二维要打断显示
  }

  //隔墙打断二维显示
  drawBreakWall() {
    //删除原有的隔墙线
    this.eraseOtherDraw();
    if (!this.startPoint || !this.endPoint || this.m_HoleIdArray.length === 0) {
      return;
    }
    if (this.mcDbId) {
      this.mcDbId.getMcDbEntity().visible = false;
    }
    let startPoint = new McGePoint3d(this.startPoint.x, this.startPoint.y, 0);
    let endPoint = new McGePoint3d(this.endPoint.x, this.endPoint.y, 0);
    //计算网格的方向
    let dirLen = new THREE.Vector3(
      endPoint.x - startPoint.x,
      endPoint.y - startPoint.y,
      endPoint.z - startPoint.z
    );
    let dirWidth = dirLen.cross(new THREE.Vector3(0, 0, 1));
    dirWidth.normalize();
    if (Math.abs(this.Ecc) > 0) {
      startPoint.x -= Math.abs(dirWidth.x) * this.Ecc;
      startPoint.y += Math.abs(dirWidth.y) * this.Ecc;
      endPoint.x -= Math.abs(dirWidth.x) * this.Ecc;
      endPoint.y += Math.abs(dirWidth.y) * this.Ecc;
    }
    // 获取所有门窗线段
    let holeLines = [];
    let holeEcc = [];
    for (let i = 0; i < this.m_HoleIdArray.length; i++) {
      let rlDoorsWindows = getEntityData({
        Guid: this.m_HoleIdArray[i],
        classTypeName: "rlWallHole",
      });
      let holeEccNum = rlDoorsWindows.Ecc;
      //判断是否有同样的Ecc
      if (holeEcc.includes(holeEccNum)) {
        continue;
      }
      holeEcc.push(holeEccNum);
      if (rlDoorsWindows) {
        let ptLongCenterStart = rlDoorsWindows.draw2dData.ptLongCenterStart;
        let ptLongCenterEnd = rlDoorsWindows.draw2dData.ptLongCenterEnd;
        //对比ptLongCenterStart和ptLongCenterEnd距离墙起点的距离
        let distStart = ptLongCenterStart.distanceTo(startPoint);
        let distEnd = ptLongCenterEnd.distanceTo(startPoint);
        //如果ptLongCenterStart距离墙起点的距离大于ptLongCenterEnd距离墙起点的距离，则交换ptLongCenterStart和ptLongCenterEnd
        if (distStart > distEnd) {
          [ptLongCenterStart, ptLongCenterEnd] = [
            ptLongCenterEnd,
            ptLongCenterStart,
          ];
        }
        holeLines.push({
          startPoint: ptLongCenterStart,
          endPoint: ptLongCenterEnd,
        });
      }
    }

    // 按照起点到墙起点的距离排序
    holeLines.sort((a, b) => {
      let distA = a.startPoint.distanceTo(startPoint);
      let distB = b.startPoint.distanceTo(startPoint);
      return distA - distB;
    });

    // 合并重叠的门窗线段
    let mergedHoleLines = [];
    for (let i = 0; i < holeLines.length; i++) {
      let current = holeLines[i];

      // 检查是否可以与前一个线段合并
      if (mergedHoleLines.length > 0) {
        let last = mergedHoleLines[mergedHoleLines.length - 1];
        if (current.startPoint.distanceTo(last.endPoint) <= this.deviation) {
          // 合并线段，取最远的终点
          if (
            current.endPoint.distanceTo(startPoint) >
            last.endPoint.distanceTo(startPoint)
          ) {
            last.endPoint = current.endPoint;
          }
          continue;
        }
      }
      mergedHoleLines.push(current);
    }

    // 计算未被打断的线段
    let remainingSegments = [];
    let currentStart = startPoint;

    // 按顺序处理每个门窗线段
    for (let i = 0; i < mergedHoleLines.length; i++) {
      let holeLine = mergedHoleLines[i];

      // 如果当前起点到门窗起点有一定距离，添加这段线段
      if (currentStart.distanceTo(holeLine.startPoint) > this.deviation) {
        remainingSegments.push({
          startPoint: currentStart,
          endPoint: holeLine.startPoint,
        });
      }

      // 更新当前起点为门窗终点
      currentStart = holeLine.endPoint;
    }

    // 添加最后一段（如果存在）
    if (currentStart.distanceTo(endPoint) > this.deviation) {
      remainingSegments.push({
        startPoint: currentStart,
        endPoint: endPoint,
      });
    }

    //创建二维俯视图
    const vecZ = new THREE.Vector3(0, 0, 1);
    let vecLong = new THREE.Vector3()
      .subVectors(endPoint, startPoint)
      .normalize();
    let vecShort1 = new THREE.Vector3();
    vecShort1.crossVectors(vecLong, vecZ).normalize();
    let vecShort2 = new THREE.Vector3(-vecShort1.x, -vecShort1.y, -vecShort1.z);
    for (let i = 0; i < remainingSegments.length; i++) {
      let line = new McDbPolyline();
      line.addVertexAt(
        MovePt(
          remainingSegments[i].startPoint,
          vecShort1,
          this.m_sectParamData.B / 2
        )
      );
      line.addVertexAt(
        MovePt(
          remainingSegments[i].endPoint,
          vecShort1,
          this.m_sectParamData.B / 2
        )
      );
      line.addVertexAt(
        MovePt(
          remainingSegments[i].endPoint,
          vecShort2,
          this.m_sectParamData.B / 2
        )
      );
      line.addVertexAt(
        MovePt(
          remainingSegments[i].startPoint,
          vecShort2,
          this.m_sectParamData.B / 2
        )
      );
      line.isClosed = true;
      line.setxDataString("Guid", this.Guid);
      line.setxDataString("classTypeName", this.classTypeName);
      line.trueColor = new McCmColor(this.Color.r, this.Color.g, this.Color.b);
      line.visible = store.state.displayData.partitionWallDisplay;
      let polylineMcDb = rlAppObj.mxcadObject.drawEntity(line);
      this.otherDrawIds.push(polylineMcDb);
    }

    //处理文本显示控制的绑定关系
    if (this.otherDrawIds.length) {
      if (this.ModelNoTextObj) {
        this.ModelNoTextObj.belongObjId = this.otherDrawIds[0];
      }
      if (this.m_TextObj) {
        this.m_TextObj.belongObjId = this.otherDrawIds[0];
      }
      if (this.StrengthTextObj) {
        this.StrengthTextObj.belongObjId = this.otherDrawIds[0];
      }
    }
  }

  initData(obj) {
    super.initData(obj);
    this.m_gridData = obj.m_gridData;
    this.updateStartAndEndPoint();
    this.Ecc = obj.Ecc;
    this.Color = obj.Color;
    this.Mat = obj.Mat;
    this.partitionWallHeight = obj.partitionWallHeight;
    this.LinkGuids = obj.LinkGuids ? obj.LinkGuids : [];
    this.useFunctionNames = obj.useFunctionNames ? obj.useFunctionNames : [];
    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
    this.setMatName();
  }

  setMatName() {
    switch (this.Mat) {
      case 51:
        this.MatName = "砖";
        break;
      case 52:
        this.MatName = "玻璃";
        break;
      case 53:
        this.MatName = "金属";
        break;
      case 54:
        this.MatName = "轻质材料";
        break;
      case 55:
        this.MatName = "人造板材";
        break;
      case 56:
        this.MatName = "其他材料";
        break;
      default:
        this.MatName = "";
        break;
    }
  }

  updateStartAndEndPoint() {
    if (this.m_gridData && this.m_gridData != {}) {
      let tempOtherData = {};
      if (this.OtherData) {
        tempOtherData = this.OtherData;
        if (typeof tempOtherData == "string") {
          tempOtherData = JSON.parse(tempOtherData);
        }
        if (tempOtherData == "") {
          tempOtherData = {};
        } else if (typeof tempOtherData === "string") {
          tempOtherData = JSON.parse(tempOtherData);
        }
      }
      tempOtherData.startPoint = {
        x: this.m_gridData.m_stJoint.m_pt[0],
        y: this.m_gridData.m_stJoint.m_pt[1],
        z: 0,
      };
      this.startPoint = new McGePoint3d(
        this.m_gridData.m_stJoint.m_pt[0],
        this.m_gridData.m_stJoint.m_pt[1],
        0
      );
      tempOtherData.endPoint = {
        x: this.m_gridData.m_edJoint.m_pt[0],
        y: this.m_gridData.m_edJoint.m_pt[1],
        z: 0,
      };
      this.endPoint = new McGePoint3d(
        this.m_gridData.m_edJoint.m_pt[0],
        this.m_gridData.m_edJoint.m_pt[1],
        0
      );
      this.OtherData = JSON.stringify(tempOtherData);
    } else {
      this.m_gridData = null;
      let tempOtherData = this.OtherData;
      if (typeof this.OtherData == "string") {
        tempOtherData = JSON.parse(this.OtherData);
        let num = 0; //避免死循环
        while (typeof tempOtherData == "string" && num < 5) {
          num++;
          tempOtherData = JSON.parse(tempOtherData);
        }
      }

      if (tempOtherData.startPoint && tempOtherData.endPoint) {
        this.startPoint = new McGePoint3d(
          tempOtherData.startPoint.x,
          tempOtherData.startPoint.y,
          0
        );
        this.endPoint = new McGePoint3d(
          tempOtherData.endPoint.x,
          tempOtherData.endPoint.y,
          0
        );
      }
    }
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      if (!this.startPoint || !this.endPoint) {
        this.updateStartAndEndPoint();
        if (!this.startPoint || !this.endPoint) return;
      }
      let isArc =
        this.m_gridData &&
        (this.m_gridData.m_centerJoint ||
          (this.m_gridData.m_Axis && this.m_gridData.m_Axis.IsMainAxis < 0));
      let ptCenter = null;
      let dRadius = 0;
      if (isArc) {
        ptCenter = this.m_gridData.mcDbGrid.center;
        dRadius = this.m_gridData.mcDbGrid.radius;
      }

      let stJointHDiff = this.m_gridData
        ? this.m_gridData.m_stJoint.HDiff
          ? Number(this.m_gridData.m_stJoint.HDiff)
          : 0
        : 0;
      let edJointHDiff = this.m_gridData
        ? this.m_gridData.m_edJoint.HDiff
          ? Number(this.m_gridData.m_edJoint.HDiff)
          : 0
        : 0;

      let res = getPKPM_PartitionWallData(
        this.m_sectParamData.Kind,
        Number(this.m_sectParamData.B),
        this.startPoint.x,
        this.startPoint.y,
        this.endPoint.x,
        this.endPoint.y,
        this.LevelB,
        Number(this.partitionWallHeight),
        this.Ecc,
        isArc,
        ptCenter,
        dRadius,
        stJointHDiff,
        edJointHDiff
      );
      if (!res) return;
      res = JSON.parse(res);
      res.startPoint = {
        x: this.startPoint.x,
        y: this.startPoint.y,
        z: 0,
      };
      res.endPoint = {
        x: this.endPoint.x,
        y: this.endPoint.y,
        z: 0,
      };
      this.getModelDrawData(res);

      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        // 如果不是数组，则将字符串转换为数组并将元素转换为数字
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   this.index2dData = modelData["upViewData"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  //   let drawing_3d = modelData["Drawing_3D"];
  //   console.log("drawing_3d", drawing_3d);

  //   this.points = drawing_3d.points;
  //   this.index3dData = {
  //     points: drawing_3d.points,
  //     faces: drawing_3d.faces,
  //   };
  // }

  draw() {
    this.m_sectGroupName = this.m_sectParamData.B.toString();
    super.draw();
    this.CurrtSect = this.m_sectGroupName;
    //与网格数据绑定
    this.m_gridData ? (this.m_gridData.m_partitionWallId = this.Guid) : "";
    this.drawBreakWall();
  }

  updateThisObj(obj, redraw = true, vecMove = null) {
    super.updateThisObj(obj, redraw);
    this.updateStartAndEndPoint();
    this.setMatName();
    if (redraw && this.m_HoleIdArray) {
      //判断墙上是否有墙洞,同步更新墙洞数据
      this.m_HoleIdArray.forEach((m_HoleId) => {
        let rlWallHoleAssociation = getEntityData({
          Guid: m_HoleId,
          classTypeName: "rlWallHole",
        });
        if (rlWallHoleAssociation) {
          rlWallHoleAssociation.saveEditRevokeData();
          rlWallHoleAssociation.m_partitionWallThick = this.m_sectParamData.B;
          rlWallHoleAssociation.isWasmGeted = false;
          rlWallHoleAssociation.updateThisObj(
            rlWallHoleAssociation,
            true,
            vecMove
          );
        }
      });
      this.drawBreakWall();
    }
  }

  // 克隆
  myClone() {
    let newObj = new rlPartitionWallData();
    super.cloneData(newObj);
    newObj.m_gridData = null;
    newObj.Ecc = this.Ecc;
    newObj.Mat = this.Mat;
    newObj.MatName = this.MatName;
    newObj.partitionWallHeight = this.partitionWallHeight;
    newObj.Color = this.Color;
    newObj.points = this.points;
    newObj.OtherData = this.OtherData;
    newObj.startPoint = this.startPoint;
    newObj.endPoint = this.endPoint;
    newObj.useFunctionNames = this.useFunctionNames;
    return newObj;
  }

  transformBy(vecMove) {
    //判断移动方向是否与网格方向垂直
    let stPoint = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
    let edPoint = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
    let gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);

    if (
      // lineDirection.x * lineDirection.y <= 0 &&
      gridVec.x < 0 ||
      gridVec.y < 0
    ) {
      let tmp = stPoint;
      stPoint = edPoint;
      edPoint = tmp;
      gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);
    }

    // 计算点积
    const dotProduct = gridVec.dot(vecMove);

    // 判断点积是否为零，考虑浮点数精度误差
    const epsilon = 1e-5; // 可以根据需要调整这个阈值
    const arePerpendicular = Math.abs(dotProduct) < epsilon;

    //计算梁的偏轴
    if (arePerpendicular) {
      //计算叉积
      const crossProduct = new THREE.Vector3().crossVectors(gridVec, vecMove);
      if (crossProduct.z < 0) {
        this.Ecc -= vecMove.length();
      } else {
        this.Ecc += vecMove.length();
      }

      // this.draw();
      // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
      this.updateThisObj(this);
    }
  }

  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["Mat"] = this.Mat;
    data["Height"] = this.partitionWallHeight;
    data["LinkGuids"] = this.LinkGuids?.join(",");

    data["SpaceName"] = this.useFunctionNames
      ? JSON.stringify(this.useFunctionNames)
      : "";
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();
    data["SectGuid"] = this.m_sectParamData.Guid;

    data["m_gridData"] = this.m_gridData ? this.m_gridData.Guid : null;
    data["Ecc"] = this.Ecc;
    data["Mat"] = this.Mat;
    data["partitionWallHeight"] = this.partitionWallHeight;
    data["LinkGuids"] = this.LinkGuids;

    data["useFunctionNames"] = JSON.stringify(this.useFunctionNames);
    data["m_HoleIdArray"] = this.m_HoleIdArray;
    return data;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = getEntityData({
      Guid: obj.m_gridData,
      classTypeName: "rlGrid",
    }); //obj.m_gridData.mcDbGridId.getMcDbEntity();
    if (!this.m_gridData) {
      this.m_gridData = getEntityData({
        Guid: obj.m_gridData,
        classTypeName: "rlGridC",
      }); //rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    }
    this.Ecc = obj.Ecc;
    this.Mat = obj.Mat;
    this.partitionWallHeight = obj.partitionWallHeight;
    this.startPoint = obj.startPoint;
    this.endPoint = obj.endPoint;
    this.useFunctionNames = JSON.parse(obj.useFunctionNames);
    this.m_HoleIdArray = obj.m_HoleIdArray;

    this.setMatName();
  }

  // 判断两个墙是否可以合并
  canMergeWalls(wall1, wall2) {
    // 检查墙的属性是否相同
    return (
      wall1.Mat === wall2.Mat &&
      wall1.partitionWallHeight === wall2.partitionWallHeight &&
      wall1.m_sectParamData.B === wall2.m_sectParamData.B
    );
  }
  mergePartitionWalls() {
    //如果隔墙有网格数据,则不合并
    if (!this.startPoint || !this.endPoint || this.m_gridData) return;
    // 获取所有隔墙数据
    const allPartitionWalls =
      store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
    if (!allPartitionWalls) return;

    // 找到与当前隔墙端点重合的其他隔墙
    let StartConnectedWalls = [];
    let EndConnectedWalls = [];
    for (let wall of allPartitionWalls) {
      if (wall.Guid === this.Guid) continue; // 跳过自身
      //如果隔墙有网格数据,则不合并
      if (!wall.startPoint || !wall.endPoint || wall.m_gridData) continue;
      // 检查端点是否重合
      if (
        isPointEqual(wall.startPoint, this.startPoint) ||
        isPointEqual(wall.endPoint, this.startPoint)
      ) {
        StartConnectedWalls.push(wall);
      }
      if (
        isPointEqual(wall.startPoint, this.endPoint) ||
        isPointEqual(wall.endPoint, this.endPoint)
      ) {
        EndConnectedWalls.push(wall);
      }
    }
    // 如果找到两个相连的墙，尝试合并它们
    if (StartConnectedWalls.length === 2) {
      this.merge(StartConnectedWalls);
    }
    if (EndConnectedWalls.length === 2) {
      this.merge(EndConnectedWalls);
    }
  }

  merge(mergeWalls) {
    if (mergeWalls.length !== 2) return;
    let wall1 = mergeWalls[0];
    let wall2 = mergeWalls[1];
    if (this.canMergeWalls(wall1, wall2)) {
      let startPoint1 = wall1.startPoint;
      let endPoint1 = wall1.endPoint;
      let startPoint2 = wall2.startPoint;
      let endPoint2 = wall2.endPoint;
      //判断两堵墙平行共线
      if (!areLineCollinear(startPoint1, endPoint1, startPoint2, endPoint2)) {
        return;
      }
      //区分左右和上下
      let isLeft = startPoint1.x < startPoint2.x;
      let isDown = startPoint1.y < startPoint2.y;
      // 如果wall1不在wall2的左边或下边，则交换wall1和wall2
      if (!isLeft && !isDown) {
        [wall1, wall2] = [wall2, wall1];
        [startPoint1, startPoint2] = [startPoint2, startPoint1];
        [endPoint1, endPoint2] = [endPoint2, endPoint1];
      }
      //得到最远的两个点
      let Length1 = startPoint1.distanceTo(startPoint2);
      let Length2 = startPoint1.distanceTo(endPoint2);
      let Length3 = endPoint1.distanceTo(startPoint2);
      let Length4 = endPoint1.distanceTo(endPoint2);
      let maxStartPoint = startPoint1;
      let maxEndPoint = endPoint1;
      let maxLength = Length1;
      if (maxLength < Length2) {
        maxStartPoint = startPoint1;
        maxEndPoint = endPoint2;
        maxLength = Length2;
      }
      if (maxLength < Length3) {
        maxStartPoint = endPoint1;
        maxEndPoint = startPoint2;
        maxLength = Length3;
      }
      if (maxLength < Length4) {
        maxStartPoint = endPoint1;
        maxEndPoint = endPoint2;
        maxLength = Length4;
      }
      //更新合并后的隔墙
      //更新隔墙
      wall1.saveEditRevokeData();
      let otherData = wall1.OtherData;
      if (typeof otherData == "string") {
        otherData = JSON.parse(otherData);
      }

      try {
        for (let i = 0; i < 5; i++) {
          if (typeof otherData == "string") {
            otherData = JSON.parse(otherData);
          } else {
            break;
          }
        }
      } catch (error) {
        console.log("otherData", otherData);
      }

      otherData.startPoint = {
        x: maxStartPoint.x,
        y: maxStartPoint.y,
        z: 0,
      };
      otherData.endPoint = {
        x: maxEndPoint.x,
        y: maxEndPoint.y,
        z: 0,
      };
      otherData = JSON.stringify(otherData);
      wall1.OtherData = otherData;
      wall1.LinkGuids.push(wall2.Guid);
      wall1.isWasmGeted = false;
      wall1.updateThisObj(wall1);
      wall2.erase(false);
      //将操作步骤下的所有数据更新到数据库中
      saveDatabaseStore();
      // 更新显示
      rlAppObj.rlMxDrawObject.updateDisplay();
    }
  }
  // 删除其他绘制数据
  eraseOtherDraw() {
    this.otherDrawIds.forEach((item) => {
      if (item) {
        item.erase();
      }
    });
    this.otherDrawIds = [];
  }
  // 删除
  erase(merge = true) {
    try {
      if (merge) {
        this.mergePartitionWalls();
      }
      //删除门窗
      if (this.m_HoleIdArray) {
        this.m_HoleIdArray.forEach((m_HoleId) => {
          const objtmp = getEntityData({
            classTypeName: "rlWallHole",
            Guid: m_HoleId,
          }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);
          if (objtmp) objtmp.erase();
        });
      }
      //删除隔墙线
      this.eraseOtherDraw();
      this.m_gridData ? (this.m_gridData.m_partitionWallId = null) : "";
      super.erase();
    } catch (error) {
      console.log("error", error);
    }
  }
}

export { rlPartitionWallData };
